import { render, staticRenderFns } from "./mailinfo-list.vue?vue&type=template&id=2b798cf4&"
import script from "./mailinfo-list.vue?vue&type=script&lang=js&"
export * from "./mailinfo-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "mailinfo-list.vue"
export default component.exports